(function () {
  const selector = '[data-fsih-carousel]';

  function initCarousel(root) {
    if (!root || root.dataset.fsihReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-fsih-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-fsih-dot]'));
    const previous = root.querySelector('[data-fsih-previous]');
    const next = root.querySelector('[data-fsih-next]');
    const autoplayEnabled = root.dataset.fsihAutoplay === 'true';
    const autoplayDelay = Math.max(3000, Number.parseInt(root.dataset.fsihAutoplayDelay || '3000', 10));
    const initialIndex = Number.parseInt(root.dataset.fsihInitialIndex || '0', 10);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (slides.length < 2) return;

    root.dataset.fsihReady = 'true';
    let currentIndex = initialIndex;
    let autoplayTimer = null;
    let pointerInside = false;
    let focusInside = false;

    function stopAutoplay() {
      if (autoplayTimer === null) return;
      window.clearTimeout(autoplayTimer);
      autoplayTimer = null;
    }

    function canAutoplay() {
      return autoplayEnabled && !document.hidden && !pointerInside && !focusInside && !reducedMotion.matches;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!canAutoplay()) return;

      autoplayTimer = window.setTimeout(() => {
        showSlide(currentIndex + 1);
        startAutoplay();
      }, autoplayDelay);
    }

    function showManualSlide(index) {
      showSlide(index);
      startAutoplay();
    }

    function showSlide(index) {
      const nextIndex = (index + slides.length) % slides.length;

      currentIndex = nextIndex;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

    }

    root.fsihShowSlide = showSlide;

    previous?.addEventListener('click', () => showManualSlide(currentIndex - 1));
    next?.addEventListener('click', () => showManualSlide(currentIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => showManualSlide(index)));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showManualSlide(currentIndex - 1);
      if (event.key === 'ArrowRight') showManualSlide(currentIndex + 1);
    });

    root.addEventListener('mouseenter', () => {
      pointerInside = true;
      stopAutoplay();
    });

    root.addEventListener('mouseleave', () => {
      pointerInside = false;
      startAutoplay();
    });

    root.addEventListener('focusin', () => {
      focusInside = true;
      stopAutoplay();
    });

    root.addEventListener('focusout', (event) => {
      if (event.relatedTarget && root.contains(event.relatedTarget)) return;
      focusInside = false;
      startAutoplay();
    });

    const handleVisibilityChange = () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    };

    const handleReducedMotionChange = () => startAutoplay();

    document.addEventListener('visibilitychange', handleVisibilityChange);
    reducedMotion.addEventListener?.('change', handleReducedMotionChange);

    root.fsihDestroy = () => {
      stopAutoplay();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      reducedMotion.removeEventListener?.('change', handleReducedMotionChange);
      delete root.fsihDestroy;
      delete root.fsihShowSlide;
    };

    showSlide(initialIndex);
    startAutoplay();
  }

  function initAll(scope) {
    const container = scope || document;
    if (container.matches?.(selector)) initCarousel(container);
    container.querySelectorAll?.(selector).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll?.(selector).forEach((root) => root.fsihDestroy?.());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = document.querySelector(`[data-fsih-block-id="${event.detail.blockId}"]`);
    const root = slide?.closest(selector);
    if (!slide || !root) return;

    const slides = Array.from(root.querySelectorAll('[data-fsih-slide]'));
    root.fsihShowSlide?.(slides.indexOf(slide));
  });
})();
